function matchTemplate(_a) {
    var values = _a.values, template = _a.template, separators = _a.separators;
    return template.replace(/@(\w+)/g, function (_, key) {
        return Object.hasOwn(values, key) ? "".concat(values[key]).concat(separators[key]) : '';
    });
}
export default matchTemplate;
//# sourceMappingURL=match-template.js.map